export const LATEST_MODIFIED = "@@reduxFirestore/DOCUMENT_MODIFIED";
export const LATEST_INIT = "@@reduxFirestore/LISTENER_RESPONSE";
